import { Container, Grid, Typography } from "@mui/material";
import { Fade } from 'react-awesome-reveal';
import { TimelineConnector, Timeline, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent, TimelineSeparator } from "@mui/lab";
import FastfoodIcon from '@mui/icons-material/Fastfood';
import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import HotelIcon from '@mui/icons-material/Hotel';
import RepeatIcon from '@mui/icons-material/Repeat';
import HandymanIcon from '@mui/icons-material/Handyman';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IosShareIcon from '@mui/icons-material/IosShare';


export const Steps = () => {
  return (
    <Container id="features" style={{ scrollMarginTop: 80}} alignItems="center">
      <Fade bottom duration={1000}>
        <Typography
          component="h2"
          variant="h2"
          align="center"
          color="text.primary"
          gutterBottom
          sx={{ marginBottom: 5, fontWeight: 400 }}
        >
          It's Easy
        </Typography>
      </Fade>
      <Fade bottom duration={1000} >
        <Typography variant="body1" align="center" color="text.secondary" component="p" p={3} m={3} >
          Launch your project—just click, create, and go!
        </Typography>
      </Fade>
      <Fade bottom duration={1000}>

        <Timeline position="alternate">
          <TimelineItem>
            <TimelineOppositeContent
              sx={{ m: 'auto 0' }}
              align="right"
              variant="body2"
              color="text.secondary"
            >
              Step 1
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineConnector />
              <TimelineDot color="primary">
                <AddCircleIcon />
              </TimelineDot>
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent sx={{ py: '12px', px: 2 }}>
              <Typography variant="h6" component="span">
                Create Project
              </Typography>
              <Typography>
                Get started in just seconds—creating your first project is quick and effortless.
              </Typography>
            </TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent
              sx={{ m: 'auto 0' }}
              variant="body2"
              color="text.secondary"
            >
              Step 2
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineConnector />
              <TimelineDot color="primary">
                <HandymanIcon />
              </TimelineDot>
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent sx={{ py: '12px', px: 2 }}>
              <Typography variant="h6" component="span">
                Build
              </Typography>
              <Typography>Populate your project with data, define connections, and enrich each element with detailed info.</Typography>
            </TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent
              sx={{ m: 'auto 0' }}
              align="right"
              variant="body2"
              color="text.secondary"
            >
              Step 3
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineConnector />
              <TimelineDot color="primary">
                <IosShareIcon />
              </TimelineDot>
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent sx={{ py: '12px', px: 2 }}>
              <Typography variant="h6" component="span">
                Share
              </Typography>
              <Typography>Showcase your project and easily share it with others.</Typography>
            </TimelineContent>
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent
              sx={{ m: 'auto 0' }}
              variant="body2"
              color="text.secondary"
            >
              Step 4
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineConnector />
              <TimelineDot color="primary">
                <RepeatIcon />
              </TimelineDot>
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent sx={{ py: '12px', px: 2 }}>
              <Typography variant="h6" component="span">
                Collect feedback and Update
              </Typography>
              <Typography>Incorporate new insights or updates seamlessly to keep your project current and impactful.</Typography>
            </TimelineContent>
          </TimelineItem>
        </Timeline>
      </Fade>
    </Container>
  );
};